// extracted by mini-css-extract-plugin
module.exports = {"Mycenter":"amt_Mycenter_3Tr3x","Myheader":"amt_Myheader_2eMs1","pmar":"amt_pmar_1YnU1"};